import React, { Component } from 'react';
import Waypoint from 'react-waypoint';
import ReactMarkdown from 'react-markdown';
import { prepareMarkDown } from '../helpers/helpers.js';
import { createAbstract, formatDate, formatNumber } from '../helpers/helpers.js';
import * as d3 from 'd3';
import './summary.css';
import Texts from '../data/summary.json';
 
class Summary extends Component {
	constructor(props) {
    super(props);
    this.summaryChart = React.createRef();
    this.areaDestra = React.createRef();
    this.areaCentroDestra = React.createRef();
    this.areaSinistra = React.createRef();
    this.areaCentroSinistra = React.createRef();
    this.areaM5S = React.createRef();
    
    this.draw = this.draw.bind( this );
    this.getCoalitions = this.getCoalitions.bind( this );
    this.getMilestone = this.getMilestone.bind( this );
    this.getTotalNumberOfArticles = this.getTotalNumberOfArticles.bind( this );
    this.outputSVG = this.outputSVG.bind( this );
    this.switchView = this.switchView.bind( this );
    this.viewbox = this.viewbox.bind( this );
    this.waypointPositionChanged = this.waypointPositionChanged.bind( this );

		this.state = {
      "labels": {},
      "paths": {},
      "ready": false,
      "show": "numbers",
			"size": {
				"h": 0,
				"w": 0
			},
      "step": -1,
      "totals": {
        "days": 126,
        "global": this.getTotalNumberOfArticles(),
        "destra": this.getTotalNumberOfArticles('destra'),
        "centro-destra": this.getTotalNumberOfArticles('centro-destra'),
        "centro-sinistra": this.getTotalNumberOfArticles('centro-sinistra'),
        "sinistra": this.getTotalNumberOfArticles('sinistra'),
        "m5s": this.getTotalNumberOfArticles('m5s')
      }
		}
	}
	
	componentDidMount() {
    this.viewbox();
    window.addEventListener( 'resize', this.viewbox, false );
  }

  componentDidUpdate( prevProps, prevState ) {
    if ( ( prevState.paths && prevState.paths !== this.state.paths ) || ( !prevState.paths ) ) {
      d3.select( this.areaDestra )
        .transition()
        .ease(d3.easePoly)
        .duration(750)
        .attr( "d", this.state.paths.destra );
      d3.select( this.areaSinistra )
        .transition()
        .ease(d3.easePoly)
        .duration(750)
        .attr( "d", this.state.paths.sinistra );
      d3.select( this.areaCentroSinistra )
        .transition()
        .ease(d3.easePoly)
        .duration(750)
        .attr( "d", this.state.paths.centrosinistra );
      d3.select( this.areaM5S )
        .transition()
        .ease(d3.easePoly)
        .duration(750)
        .attr( "d", this.state.paths.m5s );
      d3.select( this.areaCentroDestra )
        .transition()
        .ease(d3.easePoly)
        .duration(750)
        .attr( "d", this.state.paths.centrodestra );
    }
  }
	
	componentWillUnmount() {
		window.removeEventListener( 'resize', this.viewbox, false );
	}

  draw() {
    let topBaseY = 0;
    let bottomBaseY = this.state.size.h - 60;
    let scaleY;
		let scaleX = d3.scaleLinear()
      .domain([
          this.props.Data.data.timeline['centro-destra'][0].timestamp, this.props.Data.data.timeline['centro-destra'][(this.props.Data.data.timeline['centro-destra'].length - 1)].timestamp
      ])
      .range( [ 0, this.state.size.w ] );
    if ( this.state.show === 'numbers') {
      scaleY = d3.scaleLinear()
        .domain( [ 0, this.props.Data.data.timeline['max'].activity ] )
        .range( [ bottomBaseY, topBaseY ] );
    } else {
      scaleY = d3.scaleLinear()
        .domain( [ 0, 100 ] )
        .range( [ bottomBaseY, topBaseY ] );
    }

    const activityArea = d3.area()
      .x( points => points.x )
      .y1( points => points.y )
      .y0( points => bottomBaseY )
      .curve( d3.curveBasis );

    let basepoints = {};
    let basepointsPerc = {};
    
    this.props.Data.data.timeline['centro-destra'].forEach(
      (item) => {
        basepoints[ item.timestamp ] = 0;
        basepointsPerc[ item.timestamp ] = 0;
      }
    );

    let destra = [];
/* */
    this.props.Data.data.timeline['destra'].forEach(
      (item) => {
        basepoints[item.timestamp] = basepoints[item.timestamp] + parseInt( item.activity, 10);
        basepointsPerc[item.timestamp] = basepointsPerc[item.timestamp] + parseInt( item.activity_perc, 10);
        destra.push({
          "a": item.activity,
          "b": basepoints[item.timestamp],
          "t": item.timestamp,
          "x": scaleX(item.timestamp),
          "y": ( this.state.show === 'numbers') ? scaleY(basepoints[item.timestamp]) : scaleY(basepointsPerc[item.timestamp])
        });
      }
    );
/* */
    let sinistra = [];
/* */
    this.props.Data.data.timeline['sinistra'].forEach(
      (item) => {
        basepoints[item.timestamp] = basepoints[item.timestamp] + parseInt( item.activity, 10);
        basepointsPerc[item.timestamp] = basepointsPerc[item.timestamp] + parseInt( item.activity_perc, 10);
        sinistra.push({
          "a": item.activity,
          "b": basepoints[item.timestamp],
          "t": item.timestamp,
          "x": scaleX(item.timestamp),
          "y": ( this.state.show === 'numbers') ? scaleY(basepoints[item.timestamp]) : scaleY(basepointsPerc[item.timestamp])
        });
      }
    );
/* */
    let centrosinistra = [];
  
    this.props.Data.data.timeline['centro-sinistra'].forEach(
      (item) => {
        basepoints[item.timestamp] = basepoints[item.timestamp] + parseInt( item.activity, 10);
        basepointsPerc[item.timestamp] = basepointsPerc[item.timestamp] + parseInt( item.activity_perc, 10);
        centrosinistra.push({
          "a": item.activity,
          "b": basepoints[item.timestamp],
          "t": item.timestamp,
          "x": scaleX(item.timestamp),
          "y": ( this.state.show === 'numbers') ? scaleY(basepoints[item.timestamp]) : scaleY(basepointsPerc[item.timestamp])
        });
      }
    );
/* */
    let m5s = [];

    this.props.Data.data.timeline['m5s'].forEach(
      (item) => {
        basepoints[item.timestamp] = basepoints[item.timestamp] + parseInt( item.activity, 10);
        basepointsPerc[item.timestamp] = basepointsPerc[item.timestamp] + parseInt( item.activity_perc, 10);
        m5s.push({
          "a": item.activity,
          "b": basepoints[item.timestamp],
          "t": item.timestamp,
          "x": scaleX(item.timestamp),
          "y": ( this.state.show === 'numbers') ? scaleY(basepoints[item.timestamp]) : scaleY(basepointsPerc[item.timestamp])
        });
      }
    );
/* */
    let centrodestra = [];
 
    this.props.Data.data.timeline['centro-destra'].forEach(
      (item) => {
        basepoints[item.timestamp] = basepoints[item.timestamp] + parseInt( item.activity, 10);
        basepointsPerc[item.timestamp] = basepointsPerc[item.timestamp] + parseInt( item.activity_perc, 10);
        centrodestra.push({
          "a": item.activity,
          "b": basepoints[item.timestamp],
          "t": item.timestamp,
          "x": scaleX(item.timestamp),
          "y": ( this.state.show === 'numbers') ? scaleY(basepoints[item.timestamp]) : scaleY(100)
        });
      }
    );

    const electionDay = new Date('2018-03-04T07:00:00').getTime() / 1000;
    const electionDayX = scaleX( electionDay );
    const electionDayEnd = new Date('2018-03-04T23:00:00').getTime() / 1000;
    const electionDayEndX = scaleX( electionDayEnd );
    const coalitions = this.getCoalitions(scaleX, scaleY, topBaseY, bottomBaseY);
    
    let calendar = [];
    let startDay = new Date('2018-02-01T00:00:00').getTime() / 1000;
    const endDay = this.props.Data.data.timeline['centro-destra'][(this.props.Data.data.timeline['centro-destra'].length - 1)].timestamp;

    startDay += ( 60 * 60 * 24 * 14 );
    while ( startDay < endDay ) {
      calendar.push({
        "x": scaleX(startDay),
        "y1": bottomBaseY,
        "y2": bottomBaseY + 5,
        "y": bottomBaseY + 18,
        "label": formatDate( startDay )
      });
      startDay += ( 60 * 60 * 24 * 14 );
    }
    
    this.setState(
      {
        "paths": {
          "destra": activityArea(destra),
          "centrodestra": activityArea(centrodestra),
          "m5s": activityArea(m5s),
          "centrosinistra": activityArea(centrosinistra),
          "sinistra": activityArea(sinistra),
          "xAxis": {
            "x1": 0,
            "y1": bottomBaseY,
            "x2": this.state.size.w,
            "y2": bottomBaseY,
            "legend": {
              "pre": {
                "arrow": "M" + (electionDayX - 5) + "," + (topBaseY + 15) + " L" + (electionDayX - 10) + "," + (topBaseY + 12) + " L" + (electionDayX - 10) + "," + (topBaseY + 18) + "Z",
                "line": {
                  "x1": 2,
                  "y1": (topBaseY + 15),
                  "x2": (electionDayX - 5),
                  "y2": (topBaseY + 15)
                },
                "stopper": {
                  "x1": 2,
                  "y1": (topBaseY + 12),
                  "x2": 2,
                  "y2": (topBaseY + 18)
                },
                "label": {
                  "x": 2 + ( (electionDayX - 5 - 2) / 2 ),
                  "y": topBaseY + 10
                }
              },
              "post": {
                "arrow": "M" + (electionDayEndX + 3) + "," + (topBaseY + 15) + " L" + (electionDayEndX + 8) + "," + (topBaseY + 12) + " L" + (electionDayEndX + 8) + "," + (topBaseY + 18) + "Z",
                "line": {
                  "x1": this.state.size.w - 2,
                  "y1": (topBaseY + 15),
                  "x2": (electionDayEndX + 5),
                  "y2": (topBaseY + 15)
                },
                "stopper": {
                  "x1": this.state.size.w - 2,
                  "y1": (topBaseY + 12),
                  "x2": this.state.size.w - 2,
                  "y2": (topBaseY + 18)
                },
                "label": {
                  "x": (electionDayEndX + 3) + ( ( this.state.size.w - 2 - (electionDayEndX + 3) ) / 2 ),
                  "y": topBaseY + 10
                }
              }
            }
          },
          "start": {
            "x1": 1,
            "y1": bottomBaseY,
            "x2": 1,
            "y2": bottomBaseY + 15
          },
          "end": {
            "x1": this.state.size.w - 1,
            "y1": bottomBaseY,
            "x2": this.state.size.w - 1,
            "y2": bottomBaseY + 15
          },
          "dates": calendar,
          "election": {
            "x1": electionDayX,
            "y1": bottomBaseY,
            "x2": electionDayX,
            "y2": bottomBaseY + 15,
            "x3": electionDayEndX,
            "x4": electionDayEndX,
            "y3": bottomBaseY,
            "y4": bottomBaseY + 15,
            "y5": topBaseY,
            "area": "M" + electionDayX + "," + bottomBaseY + " L" + electionDayEndX + "," + bottomBaseY + " L" + electionDayEndX + "," + topBaseY + " L" + electionDayX + "," + topBaseY + "Z"
          },
          "coalitions": coalitions,
        },
        "labels": {
          "start": {
            "x": 4,
            "y": bottomBaseY + 30,
            "label": formatDate( this.props.Data.data.timeline['centro-destra'][0].timestamp )
          },
          "end": {
            "x": this.state.size.w - 4,
            "y": bottomBaseY + 30,
            "label": formatDate( this.props.Data.data.timeline['centro-destra'][ (this.props.Data.data.timeline['centro-destra'].length - 1) ].timestamp )
          },
          "election": {
            "x": electionDayX + ((electionDayEndX - electionDayX) / 2),
            "y": bottomBaseY + 30,
            "label": formatDate( electionDay ),
            "y1": bottomBaseY + 44,
            "label1": "Seggi Aperti 7-23"
          }
        },
        "ready": true
      }
    );
  }

  getCoalitions(scaleX, scaleY, topBaseY, bottomBaseY) {
    let output = [];

    Texts.forEach(
      (item) => {
        let milestones = [];
        item.milestones.forEach(
          (milestone, index) => {
            let detail = this.getMilestone( milestone );
            let xPos = scaleX( detail.timestamp_order );
            let elevation = 25;
            if ( index % 2 === 1) {
              elevation = 50;
            }
            milestones.push({
              "line": {
                "x1": xPos,
                "y1": topBaseY + 20 + elevation,
                "x2": xPos,
                "y2": bottomBaseY
              },
              "text": {
                "x": xPos,
                "y": topBaseY + 12 + elevation,
                "alignment": "left",
                "elevation": 0,
                "label": index + 1
              },
              "path": "M" + xPos + "," + (topBaseY + 25 + elevation) + " L" + (xPos + 3) + "," + (topBaseY + 20 + elevation) + " L" + (xPos - 3) + "," + (topBaseY + 20 + elevation) + "Z",
              "circle": {
                "cx": xPos,
                "cy": topBaseY + 11 + elevation,
                "r": 9
              }
            });
          }
        );
        let coalition = {
          "id": item.id,
          "milestones": milestones
        }
        output.push( coalition );
      }
    );

    return output;
  }

  getMilestone( id ) {
    let output = null;
    id = parseInt(id,10);
    this.props.Data.data.milestones.forEach(
      (milestone) => {
        if ( parseInt(milestone.dbid,10) === id ) {
          output = milestone;
        }
      }
    );
    return output || false;
  }

  getTotalNumberOfArticles( area ) {
    let total = 0;
    if ( area ) {
      for (let element in this.props.Data.data.timeline[area] ) {
        total += parseInt( this.props.Data.data.timeline[area][element].activity, 10);
      }
    } else {
      for (let property in this.props.Data.data.timeline) {
        if (property !== 'max') {
          if (this.props.Data.data.timeline.hasOwnProperty(property)) {
            for (let element in this.props.Data.data.timeline[property] ) {
              total += parseInt( this.props.Data.data.timeline[property][element].activity, 10) || 0;
            }
          }
        }
      }
    }
    return total;
  }

  outputSVG() {
    if (this.state.ready) {
      return (
        <svg viewport={"0 0 " + this.state.size.w + ' ' + this.state.size.h} preserveAspectRatio="xMidYMid meet" width={this.state.size.w} height={this.state.size.h}>
          <g className="areas-group">
            <path d="" className="centro-destra" ref={ path => this.areaCentroDestra = path } />
            <path d="" className="m5s" ref={ path => this.areaM5S = path } />
            <path d="" className="centro-sinistra" ref={ path => this.areaCentroSinistra = path } />
            <path d="" className="sinistra" ref={ path => this.areaSinistra = path } />
            <path d="" className="destra" ref={ path => this.areaDestra = path } />
          </g>
          <g className="x-axis">
            <line x1={this.state.paths.xAxis.x1} x2={this.state.paths.xAxis.x2} y1={this.state.paths.xAxis.y1} y2={this.state.paths.xAxis.y2} />

            {this.state.paths.dates.map(
              (item) => {
                return (
                  <g key={item.x} className="calendar-item">
                    <line x1={item.x} x2={item.x} y1={item.y1} y2={item.y2} className="date" />
                    <text x={item.x} y={item.y} className="label-date">{item.label}</text>
                  </g>
                )
              }
            )}
          </g>
          <g className="vertical-lines vertical-lines-labels">
            <line x1={this.state.paths.start.x1} x2={this.state.paths.start.x2} y1={this.state.paths.start.y1} y2={this.state.paths.start.y2} className="start" />
            <text x={this.state.labels.start.x} y={this.state.labels.start.y} className="label-start">{this.state.labels.start.label}</text>
            <line x1={this.state.paths.end.x1} x2={this.state.paths.end.x2} y1={this.state.paths.end.y1} y2={this.state.paths.end.y2} className="end" />
            <text x={this.state.labels.end.x} y={this.state.labels.end.y} className="label-end">{this.state.labels.end.label}</text>
            <line x1={this.state.paths.election.x1} x2={this.state.paths.election.x2} y1={this.state.paths.election.y1} y2={this.state.paths.election.y2} className="election" />
            <line x1={this.state.paths.election.x3} x2={this.state.paths.election.x4} y1={this.state.paths.election.y3} y2={this.state.paths.election.y4} className="election" />
            <text x={this.state.labels.election.x} y={this.state.labels.election.y} className="label-election">{this.state.labels.election.label}</text>
            <text x={this.state.labels.election.x} y={this.state.labels.election.y1} className="label-election">{this.state.labels.election.label1}</text>

            <path d={this.state.paths.election.area} className="electionArea" />
            <line x1={this.state.paths.election.x1} x2={this.state.paths.election.x2} y1={this.state.paths.election.y1} y2={this.state.paths.election.y5} className="electionLine" />
            <line x1={this.state.paths.election.x3} x2={this.state.paths.election.x4} y1={this.state.paths.election.y1} y2={this.state.paths.election.y5} className="electionLine" />
          </g>
          <g className="horizontal-lines horizontal-lines-labels">
            <g className="pre">
              <line className="stopper" x1={this.state.paths.xAxis.legend.pre.stopper.x1} y1={this.state.paths.xAxis.legend.pre.stopper.y1} x2={this.state.paths.xAxis.legend.pre.stopper.x2} y2={this.state.paths.xAxis.legend.pre.stopper.y2} />
              <path className="arrow" d={this.state.paths.xAxis.legend.pre.arrow} />
              <line className="line" x1={this.state.paths.xAxis.legend.pre.line.x1} y1={this.state.paths.xAxis.legend.pre.line.y1} x2={this.state.paths.xAxis.legend.pre.line.x2} y2={this.state.paths.xAxis.legend.pre.line.y2} />
              <text className="label" x={this.state.paths.xAxis.legend.pre.label.x} y={this.state.paths.xAxis.legend.pre.label.y}>Prima</text>
            </g>
            <g className="post">
              <line className="stopper" x1={this.state.paths.xAxis.legend.post.stopper.x1} y1={this.state.paths.xAxis.legend.post.stopper.y1} x2={this.state.paths.xAxis.legend.post.stopper.x2} y2={this.state.paths.xAxis.legend.post.stopper.y2} />
              <path className="arrow" d={this.state.paths.xAxis.legend.post.arrow} />
              <line className="line" x1={this.state.paths.xAxis.legend.post.line.x1} y1={this.state.paths.xAxis.legend.post.line.y1} x2={this.state.paths.xAxis.legend.post.line.x2} y2={this.state.paths.xAxis.legend.post.line.y2} />
              <text className="label" x={this.state.paths.xAxis.legend.post.label.x} y={this.state.paths.xAxis.legend.post.label.y}>Dopo</text>
            </g>
          </g>
          <g className="milestones-lines">
            {this.state.paths.coalitions.map(
              (coalition, index) => {
                return (
                  <g className={"milestones-lines-group milestones-lines-" + coalition.id} key={'C-' + index}>
                    {coalition.milestones.map(
                      (milestone, index) => {
                        return (
                          <g key={'CM-' + index}>
                            <line x1={milestone.line.x1} x2={milestone.line.x2} y1={milestone.line.y1} y2={milestone.line.y2} />
                            <path d={milestone.path} className="milestones-lines-arrow" />
                            <circle cx={milestone.circle.cx} cy={milestone.circle.cy} r={milestone.circle.r} />
                            <text x={milestone.text.x} y={milestone.text.y} className={"milestone-lines-" + milestone.text.alignement + " milestone.lines-" + milestone.text.elevation}>{milestone.text.label}</text>
                          </g>
                        )
                      })}
                  </g>
                )
              })}
          </g>
        </svg>
      );
    } else {
      return null;
    }
  }

  switchView( show ) {
    if ( show !== this.state.show ) {
      this.setState({ show }, () => { this.draw(); });
    }
  }

  viewbox() {
    let svgWrapper = this.summaryChart.current.querySelector('.summary--chart--wrapper');
    let size = {
      "h": svgWrapper.offsetHeight,
      "w": svgWrapper.offsetWidth,
    }
    this.setState(
      { size },
      () => {
        this.draw();
      }
    );
  }

  waypointPositionChanged( pos, step ) {
    if ( pos.currentPosition === 'inside' ) {
      this.setState( { step } );
    }
    if ( step === 0 && pos.currentPosition === 'below' ) {
      step = -1;
      this.setState( { step } );
    }
    if ( step === 5 && pos.currentPosition === 'above' ) {
      step = -1;
      this.setState( { step } );
    }
  }
	
	render() {
    let getMilestone = this.getMilestone;
    return (
      <div className="summary in" data-step={this.state.step} data-view={this.state.show}>
        <div className="summary--legend">
          <div className="summary--legend--item item" >
            <div className="item--text">
              <div className="item--text--title">
                <h1>Gli schieramenti</h1>
              </div>
              <div className="item--text--body">
                <div>
                  <p>Iniziamo dalla copertura data dai giornali alle diverse coalizioni: abbiamo raccolto e analizzato un totale di <strong>28.837 articoli</strong>, e questa è la situazione generale durante il periodo monitorato: dal primo di febbraio al 6 giugno, pochi giorni dopo il giuramento del nuovo governo.</p>
                  <h3>Come sono stai raccolti gli articoli?</h3>
                  <p>Abbiamo utilizzato un metodo semplice: un nostro bot ha monitorato Twitter per una serie di parole chiave, e da questi tweet ha estratto eventuali link ad articoli di testate online (la <em>white-list</em> delle nostre fonti comprende testate registrate in Italia che abbiano un sito internet).</p>
                  <p>Questi articoli sono stati poi analizzati in maniera automatica al fine di categorizzarli per capire <em>di chi</em> parlano. Quando parliamo di "<strong>attività</strong>" di uno schieramento intendiamo quanti articoli che parlano di lui sono stati pubblicati. Maggiori informazioni sono disponibili nella pagina <a href="/#/leggi/come-funziona/">come funziona</a> o in <a href="https://medium.com/simone-lippolis/elezioni-io-is-a-news-aggregator-and-analysis-tool-about-the-italian-general-elections-held-on-e664001fec7a">questo articolo pubblicato su Medium</a>.</p>
                  <h3>Gli schieramenti</h3>
                  <p>Il progetto ha avuto inizio quando ancora lo scenario politico italiano era suddiviso in <strong>cinque principali schieramenti</strong> e tutte le nostre analisi riflettono questa realtà: <em>Destra</em>, <em>Centro Destra</em>, <em>Movimento 5 Stelle</em>, <em>Centro Sinistra</em>, e <em>Sinistra</em>. All'interno degli schieramenti sono stati raggruppati partiti e movimenti che non si sono necessariamente presentati assieme alle elezioni, ma che erano affini da un punto di vista politico-ideologico.</p><h3>I risultati delle elezioni</h3><p>Nelle tabelle che seguono vedrete riportate delle percentuali descritte come "<strong>risultati elettorali</strong>": la fonte di questi dati è <a href="http://www.cattaneo.org/wp-content/uploads/2018/03/Analisi-Istituto-Cattaneo-Elezioni-Politiche-2018-Chi-ha-vinto-chi-ha-perso-5-marzo-2018-2.pdf">questo documento dell'Istituto Cattaneo</a>.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <figure className="summary--chart" ref={this.summaryChart}>
          <div className="in">
            <div className="summary--chart--wrapper">
              {this.outputSVG()}
            </div>
            <div className="summary--chart--switch">
              <button onClick={() => { if (this.state.step !== 0 && this.state.step !== 6 ) { this.switchView('percent'); }}} className={(this.state.show === 'percent') ? 'active' : ''}>%</button>
              <button onClick={() => { if (this.state.step !== 0 && this.state.step !== 6 ) { this.switchView('numbers'); }}} className={(this.state.show === 'numbers') ? 'active' : ''}>#</button>
            </div>
          </div>
        </figure>
        <div className="summary--legend">

            {Texts.map(
              (item, index) => {
                return (
                  <Waypoint onPositionChange={ (position) => { this.waypointPositionChanged(position, index); } } topOffset="40%" bottomOffset="10%" key={'K-' + index}>
                    <div className="summary--legend--item item" >
                      <div className="item--text">
                        <div className="item--text--title">
                          <h2>{item.title}</h2>
                        </div>
                        <div className="item--text--body">
                          <ReactMarkdown source={prepareMarkDown(item.body)} />
                        </div>
                      </div>
                      <div className="item--stats data">
                        {item.data.map(
                          (topic, index) => {
                            let content;
                            let id;
                            let avg;
                            let percent;
                            let data;
                            if ( topic.body ) {
                              content = topic.body;
                            } else if ( topic.function ) {
                              switch (topic.function) {
                                case 'Activity-Average':
                                  id = item.id;
                                  if (id === 'intro' || id === 'conclusioni') { id = 'global'; }
                                  avg = formatNumber( Math.round( this.state.totals[id] / this.state.totals.days ));
                                  content = '# ' + avg;
                                  break;
                                case 'Activity-Total':
                                  id = item.id;
                                  if (id === 'intro' || id === 'conclusioni') { id = 'global'; }
                                  content = '# ' + formatNumber( this.state.totals[id] );
                                  break;
                                case 'Percentage-Activity':
                                  id = item.id;
                                  if (id === 'intro' || id === 'conclusioni') { id = 'global'; }  
                                  percent = formatNumber(( this.state.totals[id] * 100 / this.state.totals.global ).toFixed(2));
                                  content = '# ' + percent + '%';
                                  break;
                                case 'Percentage-Total':
                                  data = topic.data.split('|');
                                  percent = formatNumber(( this.state.totals[data[0]] * 100 / this.state.totals.global ).toFixed(2));
                                  content = '## ' + percent + '% - ' + data[1] + '\n### (attività - risultati)' + (data[2] ? '\n#### ' + data[2] : '');
                                  break;
                                default:
                                  break;
                              }
                            }
                            return (
                              <div className="data--item" key={'T-' + index}>
                                <div className="data--item--title">
                                  <h2>{topic.title}</h2>
                                </div>
                                <div className="data--item--body">
                                <ReactMarkdown source={prepareMarkDown(content)} />
                                </div>
                              </div>
                            )
                          }
                        )}
                      </div>
                      <div className="item--milestones--title">
                        <h2>Eventi importanti</h2>
                      </div>
                      <div className="item--milestones">
                        {item.milestones.map(
                          (milestoneId, index) => {
                            let milestone = getMilestone( milestoneId );
                            if (milestone) {
                              return (
                                <article className="item--milestone" key={'M-' + item.id + '-' + milestone.dbid + '-' + index}>
                                  <div className="item--milestone--title">
                                    <h2 className="badge">{index+1}</h2>
                                    <h3>{formatDate( milestone.timestamp_published )} — {milestone.source}</h3>
                                    <h1><a href={milestone.url} target="_read_">{milestone.title}</a></h1>
                                  </div>
                                  <div className="item--milestone--body">
                                    <p><a href={milestone.url} target="_read_">{createAbstract(milestone.description)} (continua a leggere su {milestone.source})</a></p>
                                  </div>
                                  <div className="item--milestone--tags">
                                    <ol>
                                      <li className="intro">Tags:</li>
                                    {milestone.tags.map(
                                      (tag, index) => {
                                        return (
                                          <li key={tag + '-' + index}>
                                            <a href={"/#/filtra/" + escape(tag.trim())}><span>{tag.trim()}</span></a>
                                          </li>
                                        )
                                      }
                                    )}
                                    </ol>
                                  </div>
                                </article>
                              );
                            } else {
                              return null;
                            }
                          }
                        )}
                      </div>
                    </div>
                  </Waypoint>
                )
              }
            )}
          
        </div>
      </div>
    );
	}
}

export default Summary;


// WEBPACK FOOTER //
// ./src/Elezioni/dataviz/summary.js